/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { SensitivityIconState, SensitivityIconSlots } from './SensitivityIcon.types';

/**
 * Render the final JSX of SensitivityIcon
 */
export const renderSensitivityIcon_unstable = (state: SensitivityIconState) => {
  assertSlots<SensitivityIconSlots>(state);

  return (
    <state.root>
      {state.backgroundIcon && <state.backgroundIcon />}
      {state.foregroundIcon && <state.foregroundIcon />}
      {state.root.children}
    </state.root>
  );
};
